import axios from "axios";
import { GLOBAL_PARAMS_URL } from "../../config";
import {
  infoEditToast
} from "../components/Toast";
import {
  EDIT_GLOBAL_PARAM,
  FETCH_GLOBAL_PARAMS
} from "./actionTypes";

/**
 * Pobieranie listy parametrów globalnych z serwera
 * 
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const fetchGlobalParams = callback => {
  return dispatch => {
    return axios
      .get(GLOBAL_PARAMS_URL)
      .then(response => {
        dispatch(fetchGlobalParamsSuccess(response.data));
      })
      .then(() => callback && callback());
  };
};

/**
 * Aktualizacja parametru globalnego na serwerze
 *
 * @param {Object} globalParam obiekt parametru do aktualizacji
 */
export const updateGlobalParams = globalParam => {
  return dispatch => {
    return axios
      .put(`${GLOBAL_PARAMS_URL}/${globalParam.id}`, JSON.stringify(globalParam), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        dispatch(updateGlobalParamsSuccess(response.data));
        infoEditToast();
      });
  };
};

/**
 * Akcja pomyślnego pobrania listy parametrów globalnych 
 * 
 * @param {Array} data obiekt listy parametrów globalnych
 */
export const fetchGlobalParamsSuccess = data => {
  return {
    type: FETCH_GLOBAL_PARAMS,
    payload: data
  };
};

/**
 * Akcja pomyślnej aktualizacji parametru globalnego 
 * 
 * @param {Object} data obiekt zaktualizowanego parametru globalnego
 */
export const updateGlobalParamsSuccess = data => {
  return {
    type: EDIT_GLOBAL_PARAM,
    payload: data
  };
};